/**
 * Local config file for Vue app.
 *
 * Uninest/Karmabooking
 *
 * Copyright (c) 2020 Karmabunny
 */

/**
 * How was the JS build (dev or production).
 * Note, production builds are also used in QA and test.
 */
export const isProduction = process.env.NODE_ENV === "production";

/**
 * The Craft environment.
 *
 * Production -> true
 * Staging -> false
 * Test -> false
 * Dev -> false
 */
export const isLive = window.__config.environment === "production";

// TODO Should this be loaded from the window.__config ?
export const GOOGLE_MAP_KEY = isLive
    ? 'AIzaSyCCq0jI1kMviu6ww64_EpwfAGThDN_4AG0'
    : 'AIzaSyC3vsFOeL7quedOZ1OQQmYPIkdOGkL9M_4';

export const MIN_STAY_WEEKS = 5;

export const MAX_STAY_WEEKS = 52;

// in Yen.
export const REGISTRATION_FEE = window.__config.registration_fee;

export const MAX_MAP_ZOOM = 15;